import React from 'react';
import { Modal, Backdrop } from '@mui/material';
import MapView from './MapView';

export default function MapModal({ open, address, name, postalCode, city, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
      }}
    >
      <div>
        <MapView 
          address={address} 
          name={name} 
          postalCode={postalCode}
          city={city}
          onClose={onClose} 
        />
      </div>
    </Modal>
  );
}
